import './new-card-series.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormCardSeries from "../form-card-series/form-card-series";
import { useNewCardSeries } from './new-card-series.hook';

export function NewCardSeries() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewCardSeries();

  return (
    <div id="NewCardSeries" className="card-series">
      <HeaderContent
        title={<h1>New Card Series</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <p>Make sure that client has branch</p>
            <FormCardSeries />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewCardSeries;